import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

// R1 token CSS (auto-generated from CRD YAML)
import '@bq/web-tokens/dist/reset.css';
import '@bq/web-tokens/dist/fonts.css';
import '@bq/web-tokens/dist/tokens.css';

import { router } from '@bq/web-surface';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
